import { RouterSerializer } from './route-serializer';
import { rootReducer } from './root-store.reducer';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import {
    NavigationActionTiming,
    StoreRouterConnectingModule,
    RouterStateSerializer
} from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../environments/environment';

@NgModule({
    imports: [
        CommonModule,
        StoreRouterConnectingModule.forRoot({
            navigationActionTiming: NavigationActionTiming.PreActivation
        }),
        StoreModule.forRoot(rootReducer, {
            metaReducers: !environment.production ? [] : [],
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true
            }
        }),
        EffectsModule.forRoot([]),
        !environment.production
            ? StoreDevtoolsModule.instrument({
                serialize: { options: true }
            })
            : []
    ],
    declarations: [],
    providers: [{ provide: RouterStateSerializer, useClass: RouterSerializer }]
})
export class RootStoreModule { }
